import React, { useEffect, useState } from 'react';

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { HtmlContent } from '../../global-component-styles';
import GlobalStyles from '../../global-styles';
import { ClearIcon, SearchIcon } from '../../utils/icons';
import {
  Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  FormControl, FormControlLabel, FormGroup, Grid, IconButton, Input, InputAdornment, InputLabel,
  Radio, RadioGroup, Table, TableCell, TableHead, TableRow, Typography
} from '../../utils/material-ui-core';

interface ConfirmProps {
  title: string;
  label: string;
  content: string;
  data: Lookup[] | LookupWithCategory[];
  yesText: string;
  noText: string;
  open: boolean;
  multiSelect: boolean;
  maxSelect: number;
  callbackOnSelect: (confirmOutput: ConfirmOutput) => void;
}

const ConfirmSelect = ({ title, label, content, data, yesText, noText, open, multiSelect, maxSelect, callbackOnSelect }: ConfirmProps) => {
  const pageStyles = LocalPageStyles();
  const globalStyles = GlobalStyles();

  const [selectedValue, setSelectedValue] = useState<LookupWithCategory[]>([]);

  const [lookupData, setlookupData] = useState<LookupWithCategory[]>([]);
  const [originalLookupData, setOriginalLookupData] = useState<LookupWithCategory[]>([]);
  const [filterLookupData, setFilterLookupData] = useState<LookupWithCategory[]>([]);
  const [searchText, setSearchText] = useState<string>("");

  const [categories, setCategories] = useState<string[]>([]);

  const setLookupSelect = (trueFalse) => {
    if (multiSelect) {

      const updateData = originalLookupData.map((rowItem) => {
        rowItem.checked = trueFalse;
        return rowItem;
      });

      setlookupData(updateData);

      searchList2(searchText, updateData);
      setTimeout(() => {
        updatedSelectedValue(originalLookupData);
      }, 300);
    }
  }

  const handelCheckBoxChange = (selectedValue: any) => {

    const updateData = originalLookupData.map((rowItem) => {
      if (rowItem.value === selectedValue) {
        rowItem.checked = !rowItem.checked;
      }
      else {
        if (!multiSelect) {
          rowItem.checked = false;
        }
      }
      return rowItem;
    });
    setlookupData(updateData);


    searchList(searchText);
    setTimeout(() => {
      updatedSelectedValue(originalLookupData);
    }, 300);
  };

  const updatedSelectedValue = (rowItems) => {
    setSelectedValue(rowItems.filter((rowItem) => rowItem.checked));
    radioSelected(rowItems.filter((rowItem) => rowItem.checked));
  };

  const searchList = (searchString: string) => {
    return searchList2(searchString, lookupData);
  }

  const searchList2 = (searchString: string, searchdata) => {
    if (searchString === "") {
      setFilterLookupData(searchdata);
      getDistinctCategories(searchdata);
    } else {
      const filterSearchData = searchdata.filter((item) => item.name.toUpperCase().indexOf(searchString.toUpperCase()) >= 0 || item.category.toUpperCase().indexOf(searchString.toUpperCase()) >= 0);
      setFilterLookupData(filterSearchData);
      getDistinctCategories(filterSearchData);
    }
  };

  const getDistinctCategories = (lookupData) => {
    const tempCategories: string[] = [];

    setCategories([]);

    lookupData.forEach((item) => {
      if (tempCategories.indexOf(item.category) < 0) {
        tempCategories.push(item.category);
      }
    });

    setCategories(tempCategories.sort());
  }

  const handleSearchTextChange = (e: React.ChangeEvent<any>) => {
    setSearchText(e.target.value);
    searchList(e.target.value);
  };

  const cancel = () => {
    if (multiSelect) {
      callbackOnSelect({ status: "cancel", data: [] });
    } else {
      callbackOnSelect({ status: "cancel", data: null });
    }
  };

  const radioSelected = (val: any) => {
    if (!multiSelect && val.length > 0) {
      //callbackOnSelect({ status: "select", data: val[0] });
    }
  };

  const selected = () => {
    const returnSelectedValues: Lookup[] = [];

    selectedValue.forEach((item) => {
      returnSelectedValues.push({ value: item.value, name: item.name, checked: item.checked });
    });
    if (multiSelect) {
      callbackOnSelect({ status: "select", data: returnSelectedValues });
    } else {
      callbackOnSelect({ status: "select", data: returnSelectedValues[0] });
    }
  };

  const shouldDisableCheckbox = (value: boolean) => {
    if (!maxSelect) {
      return false;
    } else if (maxSelect === 0) {
      return false;
    }

    const totalItemSelected = data.filter((rowItem) => rowItem.checked).length;
    if (totalItemSelected < maxSelect) {
      return false;
    } else if (value) {
      return false;
    }

    return true;
  };



  useEffect(() => {

    if (!open) {
      setlookupData([]);
      setOriginalLookupData([]);
      setFilterLookupData([]);
      setSearchText("");
      setSelectedValue([]);
    }
    else {

      const tempData: LookupWithCategory[] = [];
      data.forEach((item) => {
        let category: string = "";

        try {
          category = (item as any).category as string;

          if (category === undefined || category.toLowerCase() === "default") {
            category = "";
          }
        } catch { }

        if (category === "" || category === null || category === undefined) {
          category = "";
        }
        tempData.push({ value: item.value, name: item.name, checked: item.checked, category: category });
      });

      getDistinctCategories(data);
      setOriginalLookupData(tempData);
      setlookupData(tempData);
      setFilterLookupData(tempData);
      setSearchText("");
      setSelectedValue([]);

      searchList2("", tempData);

      if (data.length > 0) {
        setTimeout(() => {
          updatedSelectedValue(tempData);
        }, 2000);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, data]);

  // useEffect(() => {
  //   if (!open) {
  //     setlookupData([]);
  //     setOriginalLookupData([]);
  //     setFilterLookupData([]);
  //     setSearchText("");
  //     setSelectedValue([]);
  //   }

  // }, [open]);


  return (
    <Dialog className={globalStyles.dialogContainer} open={open} maxWidth={"md"} fullWidth={true}>
      <DialogTitle id="input-dialog-title" className={globalStyles.dialogTitleContainer}>
        <Typography variant="body1" component="div">
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        {content !== "" ? (
          <DialogContentText className={pageStyles.contentText} component="div">
            <HtmlContent dangerouslySetInnerHTML={{ __html: content }}></HtmlContent>
            <Box>&nbsp;</Box>
          </DialogContentText>
        ) : null}

        <Grid container spacing={0}>

          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel>Search Text</InputLabel>
              <Input
                autoFocus
                required
                type="text"
                id="searchText"
                name="searchText"
                value={searchText}
                onChange={handleSearchTextChange}
                endAdornment={
                  <InputAdornment position="end">
                    {searchText.length > 0 ? (
                      <IconButton
                        aria-label="Clear search text."
                        onClick={() => {
                          setSearchText("");
                          searchList("");
                        }}
                      >
                        <ClearIcon />
                      </IconButton>
                    ) : (
                      <SearchIcon color="disabled" />
                    )}
                  </InputAdornment>
                }
              />
            </FormControl>
            <Box>&nbsp;</Box>
          </Grid>

          <Grid item xs={12}>
            {
              multiSelect && maxSelect === 0 ?
                <>
                  <Box p={1}></Box>
                  <Table size="small" className={pageStyles.customTable} >
                    <TableHead>
                      <TableRow>
                        <TableCell>Select</TableCell>
                        <TableCell align="right">
                          <Button variant="contained" size="small" color="secondary" className={pageStyles.selectButton} onClick={() => { setLookupSelect(true) }}>All</Button>
                          &nbsp;&nbsp;
                          <Button variant="contained" size="small" className={pageStyles.selectButton} onClick={() => { setLookupSelect(false) }}>None</Button>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                  </Table>
                  <Box p={1}></Box>
                </>
                :
                <Box p={1}></Box>
            }
          </Grid>

          <Grid item xs={12}>
            <Box className={pageStyles.dialogContentContainer}>
              <FormGroup>
                {multiSelect ? (
                  <>
                    {
                      categories.map((category, index) => (
                        <Box key={index}>
                          {
                            category !== "" ?
                              <Box className={globalStyles.topic}>{category}</Box>
                              :
                              <Box>&nbsp;</Box>
                          }

                          {
                            filterLookupData
                              .filter((item) => item.category === category)
                              .map((item, index) => (
                                <Box key={index}>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={item.checked}
                                        value={item.value}
                                        name={item.value}
                                        onChange={(event: any) => {
                                          handelCheckBoxChange(event.target.value);
                                        }}
                                        disabled={shouldDisableCheckbox(item.checked)}
                                        disableRipple
                                      />
                                    }
                                    label={item.name}
                                  />
                                </Box>
                              ))
                          }
                        </Box>
                      ))
                    }
                  </>
                ) : (
                  <RadioGroup name="gender1" >

                    {
                      categories.map((category, index) => (
                        <Box key={index}>
                          {
                            category !== "" ?
                              <Box className={globalStyles.topic}>{category}</Box>
                              :
                              <Box>&nbsp;</Box>
                          }

                          {
                            filterLookupData
                              .filter((item) => item.category === category)
                              .map((item, index) => (
                                <Box key={index}>
                                  <FormControlLabel
                                    value={item.value}
                                    checked={item.checked}
                                    control={<Radio />}
                                    label={item.name}
                                    onChange={(event: any) => {
                                      handelCheckBoxChange(event.target.value);
                                    }}
                                  />
                                </Box>
                              ))
                          }

                        </Box>
                      ))
                    }



                  </RadioGroup>
                )}
              </FormGroup>
              <Box p={1}>&nbsp;</Box>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button disabled={selectedValue.length > 0 ? false : true} onClick={() => selected()} color="secondary" variant="contained" className={globalStyles.buttonDefault}>
          {yesText}
          {multiSelect && selectedValue.length > 0 ? " (" + selectedValue.length + ")" : null}
        </Button>
        <Button onClick={() => cancel()} autoFocus className={globalStyles.buttonDefault}>
          <u>{noText}</u>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const LocalPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    contentText: {
      whiteSpace: "pre-wrap",
    },
    dialogContentContainer: {
      minHeight: "400px",
      height: "calc(100vh - 380px)",
      overflow: "auto",
      width: "100%",
      "& .MuiTypography-body1": {
        whiteSpace: 'nowrap'
      }
    },
    customTable: {

      "& .MuiTableCell-root": {
        paddingRight: 10,
        paddingLeft: 5,
        backgroundColor: theme.palette.type === "dark" ? theme.palette.grey[800] : theme.palette.grey[100],
      }
    },
    selectButton: {
      maxHeight: '25px',
      minWidth: '55px',

      "& .MuiButton-label": {
        fontSize: "0.8em",
      }
    },
  })
);

export default ConfirmSelect;
